import { call, put } from 'redux-saga/effects';
import LoginActions from '../actions/LoginActions';

const { logoutRequest } = LoginActions;

const badRequestStatuses = [401];

export function* callApi(api, method, ...restArgs) {
  const result = yield call(api[method], ...restArgs);
  if (result.ok === false && badRequestStatuses.includes(result.status)) {
    yield put(logoutRequest());
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/state/sagas/Api.js